import formMixin from '../../../mixins/formMixin'

export default {
    name: 'FormInput',

    mixins: [formMixin]
}
